/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const personSearchItemSchema = z.object({
  id: z.number(),
  slug: z.string(),
  name: z.string(),
  avatarPath: z.string().nullable().optional(),
  knownForDepartment: z.string().nullable().optional(),
});

export type IPersonSearchItem = z.infer<typeof personSearchItemSchema>;

export const searchPeopleResponseSchema = createApiResponseSchema(
  z.array(personSearchItemSchema),
) as import('zod').ZodSchema<IAPI<IPersonSearchItem[]>>;

export type ISearchPeopleResponse = IAPI<IPersonSearchItem[]>;
